module.exports = __webpack_public_path__ + "static/media/team-member.f39bec78.jpg";